import { atom } from "recoil";

export const addStateSalesType = atom({
  key: "addStateSalesType",
  default: false,
});
export const editStateSalesType = atom({
  key: "editStateSalesType",
  default: false,
});
export const rowEditIdStateSalesType = atom({
  key: "rowEditIdStateSalesType",
  default: null,
});
export const disableButtonStateSalesType = atom({
  key: "disableButtonStateSalesType",
  default: false,
});

export const selectedRowsStateSalesType = atom({
  key: "selectedRowsStateSalesType",
  default: [],
});

export const setFilterTextSalesType = atom({
  key: "setFilterTextSalesType",
  default: "",
});
